import { render } from "./BookHome.vue?vue&type=template&id=064ea7c0&scoped=true"
import script from "./BookHome.vue?vue&type=script&lang=js"
export * from "./BookHome.vue?vue&type=script&lang=js"

import "./BookHome.vue?vue&type=style&index=0&id=064ea7c0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064ea7c0"]])

export default __exports__